import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const InfoLabelsContainer = styled.div`
  padding-top: 10px;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
`;

export const RatingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70%;
  color: ${colors.darkGray};
  font-weight: 600;
  font-size: 30px;
`;

export const BestScoreContainer = styled.div``;

export const SubmissionContainer = styled.div`
  position: relative;
  display: block;
  margin-bottom: 1rem;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 0.25rem;
  box-shadow: 0 5px 15px rgb(0 0 0 / 30%);
  padding: 20px;
  margin: 10px 20px;
`;

export const MatchTable = styled.div`
  display: flex;
`;

export const TableTitle = styled.div`
  display: flex;
  justify-content: ${({ makeLeft }) => (makeLeft ? `flex-start` : `center`)};
  align-items: center;
  padding: 15px;

  ${({ isHead }) =>
    isHead &&
    css`
      font-weight: 600;
    `};
`;

export const TableRow = styled.div`
  display: flex;

  ${({ hasHoverCursor }) =>
    hasHoverCursor &&
    css`
      :hover {
        color: ${colors.fsDarkBlue};
        cursor: pointer;
      }
    `};

  ${({ isGreyRow }) =>
    isGreyRow &&
    css`
      background-color: ${isGreyRow ? colors.lightGray : colors.white};
    `};
`;

export const SubmissionInfoLabelsContainer = styled.div``;

export const CodeContainer = styled.div`
  padding: 5px;
  font-size: 14px;

  code {
    white-space: pre-wrap !important;
  }
`;
